import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, SubCard, SubCardContainer, SubCardTitle, SessionsContainer, RightAlignedButton } from "../../common_components/Layout";
import { EditableFieldsContainer, EditableField } from "../../common_components/EditableFields";
import { DropdownQuestion, DropdownOption } from "../../common_components/Forms";
import Modal from "../../common_components/Modal";
import LoadingIcon from "../../common_components/LoadingIcon";
import { PrimaryButton, SecondaryButton } from "../../common_components/Buttons";


// Api Calls
import MissionsAPI from "../../../api/api_calls/MissionAPI";


function StatusCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()

    //Format Modal State
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const toggleModal = () => {
        setModalIsOpen(!modalIsOpen);
    }

    const [submitLoading, setSubmitLoading] = useState(false);

    const statuses = {
        "open": "Project is open to applications ",
        // Closed is overruled below so that we can bold it.
        "closed": "Permanently closed. Contact info@despark.io to make changes.",
        "paused": "Project is temporarily closed. No new respondents can apply.",
        "draft": "Project has not yet launched. Fill out the rest of the information to launch your project."
    }



    function submitUpdate(status) {

        const submitValue = {}
        submitValue["status"] = status
        submitValue["missionId"] = missionId
        submitValue["handleRedirect"] = navigate

        async function updateMission() {
            const result = await MissionsAPI.update(submitValue);

            if (result.success) {
                alert.show("Project updated", { type: 'success' })
                props.refreshMission()
                setSubmitLoading(false);
                setModalIsOpen(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        async function closeMission() {
            const result = await MissionsAPI.close({ missionId: missionId, handleRedirect: navigate });

            if (result.success) {
                alert.show("Project closed", { type: 'success' })
                props.refreshMission()
                setSubmitLoading(false);
                setModalIsOpen(false);
            } else {
                alert.show("Error closing mission. Please contact info@despark.io", { type: 'error' })
                setSubmitLoading(false);
                setModalIsOpen(false);
            }
        }

        setSubmitLoading(true);
        if (status == "closed") {
            closeMission();
        } else {
            updateMission();
        }
    }

    console.log("Mission status: ", props.mission.status)
    console.log("Mission is closed ", props.mission.status == "closed")


    return (
        <>
            <Card style={{ flexGrow: 1, width: "100%", justifyContent: "space-between" }}>
                <GrayCardTitle title="Status" />
                {props.loading ? <LoadingIcon /> :
                    <>
                        <StatusIndicator status={props.mission.status} statuses={statuses} />
                        <RightAlignedButton>
                            {props.mission.status != "closed" && <SecondaryButton onClick={toggleModal} text="Edit" submitLoading={props.submitLoading} />}
                        </RightAlignedButton>
                    </>
                }
            </Card>
            {modalIsOpen && <ChangeStatusModal isOpen={modalIsOpen} status={props.mission.status} submitUpdate={submitUpdate} toggleModal={toggleModal} statuses={statuses} submitLoading={submitLoading} />}
        </>


    )
}

function StatusIndicator(props) {


    return (
        <div className="status-div">
            <div className={"status-primary-text " + props.status}>
                {props.status ? props.status.charAt(0).toUpperCase() + props.status.slice(1) : "Draft"}
            </div>
            <div className="status-description">{props.statuses[props.status]}</div>
        </div>
    )
}

function ChangeStatusModal(props) {

    const [status, setStatus] = useState(props.status);
    const style = {
        maxWidth: "350px",
        gap: "32px"
    }

    function onChangeStatus(event) {
        setStatus(event.target.value);
    }





    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen}>
            <Card style={style}>
                <div className="modal-title">
                    Update Project Status
                </div>
                <div className="dropdown-and-text-container">
                    <DropdownQuestion questionText="Status" name="status" id="status" value={status || props.status} onChange={onChangeStatus} widthClass="mw-400 w-100">
                        <DropdownOption value={"open"}>Open</DropdownOption>
                        <DropdownOption value={"paused"}>Paused</DropdownOption>
                        <DropdownOption value={"closed"}>Closed</DropdownOption>
                    </DropdownQuestion>
                    <div className="dropdown-explanation-text">
                        {(status || props.status) == "closed" ?
                            <><b>Permanently close </b>your project. No new respondents can apply, and you will be charged for the remaining balance.</>
                            :
                            props.statuses[status || props.status]
                        }
                    </div>
                </div>
                <div className="align-button-right">
                    <PrimaryButton text="Update" onClick={() => props.submitUpdate(status)} submitLoading={props.submitLoading} />
                </div>
            </Card>
        </Modal>
    )

}

export default StatusCard;